var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project != undefined)?_c('div',{staticStyle:{"clear":"both"},attrs:{"id":"app-footer"}},[_vm._v(_vm._s(_vm.copyright.value))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }